(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialized-category-carousel"] && !Shopify.designMode) return;
  try {
    
  // Keep this deck's arrows in sync with the actual scroll boundaries, including
  // partially visible cards and resizing, while reusing the theme's slideshow.
  if (!customElements.get('sp-category-deck-controls')) {
    class SpecializedCategoryDeckControls extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const scroller = this.closest('slideshow-component')?.querySelector('[ref="scroller"]');
          const previous = this.querySelector('[data-direction="previous"]');
          const next = this.querySelector('[data-direction="next"]');
          if (!scroller || !previous || !next) return;

          const update = () => {
            const end = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
            const offset = Math.abs(scroller.scrollLeft);
            previous.disabled = offset <= 2;
            next.disabled = offset >= end - 2;
            this.hidden = end <= 2;
          };

          this.controller = new AbortController();
          scroller.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(scroller);
          for (const slide of scroller.children) {
            this.resizeObserver.observe(slide);
          }
          update();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    }

    customElements.define('sp-category-deck-controls', SpecializedCategoryDeckControls);
  }

  } catch(e) { console.error(e); }
})();
})();
